import { createSelector, createSlice } from '@reduxjs/toolkit';
import { EmpresaTabByName } from "../constants";
import { societarioFiltroSelector } from "./societarioFiltro";

const initialState = {
  empresas: [],
};

export const empresasSelector = state => state.societarioTabela.empresas;
export const empresasFiltradasSelector = createSelector(
  empresasSelector,
  societarioFiltroSelector,
  (empresas, filtro) => {
    if (filtro.empresaNome) {
      return empresas.filter(empresa => (empresa.apelido || empresa.razaoSocial).includes(filtro.empresaNome));
    }
    return empresas;
  }
)

export const slice = createSlice({
  name: 'societarioTabela',
  initialState,
  reducers: {
    fetchTabela(state, action) {
      state.empresas = [];
      action.payload.empresas.forEach(empresa => {
        const abas = action.payload.alertasByEmpresaId[empresa.id]
          ?.filter(aba => EmpresaTabByName[aba.nome]?.modulos?.includes('societario') === true)
          ?.reduce((pv, cv) => {
            pv[cv.nome] = cv;
            return pv;
          }, {}) ?? {};
        state.empresas.push({ ...empresa, abas });
      });
    },
  },
  extraReducers: {},
});

export default slice.reducer;

export const { fetchTabela } = slice.actions;
